<output *ngIf="summaryLoading" class="panel muted">Loading connectivity summary...</output>
<div *ngIf="summaryError" class="panel conn-error" role="alert">
  <span>{{ summaryError }}</span>
  <button type="button" class="btn btn-outline-primary btn-sm" (click)="loadConnectivitySummary()">Retry</button>
</div>

<div class="conn-page-layout" *ngIf="summary as data">
  <!-- API summary cards -->
  <div class="conn-kpi-grid">
    <article class="kpi-card conn-kpi-card" *ngFor="let card of data.cards">
      <div class="conn-kpi-icon conn-kpi-icon--blue"><i class="pi pi-chart-bar" aria-hidden="true"></i></div>
      <div class="conn-kpi-body">
        <span class="kpi-label">{{ card.title }}</span>
        <div class="kpi-value">{{ card.count | number:(card.title === 'Connectivity Rate' ? '1.0-1' : '1.0-0') }}{{ card.title === 'Connectivity Rate' ? '%' : '' }}</div>
        <div class="kpi-delta">{{ card.desc }}</div>
      </div>
    </article>
  </div>

  <div class="conn-charts-row">
    <article class="panel conn-chart-panel">
      <h3 class="section-title">{{ data.line_bars.LineBar1.title }}</h3>
      <p class="muted">{{ data.line_bars.LineBar1.desc }}</p>
      <apx-chart
        [series]="deploymentVsConnectedChart.series"
        [chart]="deploymentVsConnectedChart.chart"
        [plotOptions]="deploymentVsConnectedChart.plotOptions"
        [colors]="deploymentVsConnectedChart.colors"
        [dataLabels]="deploymentVsConnectedChart.dataLabels"
        [xaxis]="deploymentVsConnectedChart.xaxis"
        [yaxis]="deploymentVsConnectedChart.yaxis"
        [legend]="deploymentVsConnectedChart.legend"
        [tooltip]="deploymentVsConnectedChart.tooltip"
        [grid]="deploymentVsConnectedChart.grid">
      </apx-chart>
      <div class="conn-rate-footer">
        Connectivity Rate: <strong>{{ connectivityRate === null ? '-' : (connectivityRate | number:'1.0-1') + '%' }}</strong>
      </div>
    </article>

    <article class="panel conn-chart-panel">
      <h3 class="section-title">{{ data.line_bars.LineBar2.title }}</h3>
      <p class="muted">{{ data.line_bars.LineBar2.desc }}</p>
      <apx-chart
        [series]="connectivityByNamcChart.series"
        [chart]="connectivityByNamcChart.chart"
        [plotOptions]="connectivityByNamcChart.plotOptions"
        [colors]="connectivityByNamcChart.colors"
        [dataLabels]="connectivityByNamcChart.dataLabels"
        [xaxis]="connectivityByNamcChart.xaxis"
        [yaxis]="connectivityByNamcChart.yaxis"
        [legend]="connectivityByNamcChart.legend"
        [tooltip]="connectivityByNamcChart.tooltip"
        [grid]="connectivityByNamcChart.grid">
      </apx-chart>
    </article>

    <article class="panel conn-chart-panel">
      <h3 class="section-title">{{ data.line_bars.LineBar3.title }}</h3>
      <p class="muted">{{ data.line_bars.LineBar3.desc }}</p>
      <apx-chart
        [series]="connectivityBySourceChart.series"
        [chart]="connectivityBySourceChart.chart"
        [plotOptions]="connectivityBySourceChart.plotOptions"
        [colors]="connectivityBySourceChart.colors"
        [dataLabels]="connectivityBySourceChart.dataLabels"
        [xaxis]="connectivityBySourceChart.xaxis"
        [yaxis]="connectivityBySourceChart.yaxis"
        [legend]="connectivityBySourceChart.legend"
        [tooltip]="connectivityBySourceChart.tooltip"
        [grid]="connectivityBySourceChart.grid">
      </apx-chart>
    </article>
  </div>

  <article class="panel">
    <div class="section-head-row">
      <div>
        <h3 class="section-title">Connectivity by NAMC / Shop</h3>
        <p class="muted">Expand a NAMC to view its mapped shops. Overall connectivity and status are reported by the API.</p>
      </div>
    </div>
    <div class="table-wrap">
      <table class="data-table conn-table">
        <thead>
          <tr>
            <th>NAMC / Shop</th>
            <th class="numeric">Shops</th>
            <th class="numeric">SAYKA Status</th>
            <th class="numeric td-connected-head">Equipment Connected</th>
            <th class="numeric td-missing-head">Equipment Planned</th>
            <th class="numeric td-connected-pct-head">Equipment Connectivity</th>
            <th class="numeric">PdM Sensors Configured</th>
            <th class="numeric">PdM Sensors Planned</th>
            <th>PdM Sensors Connectivity</th>
            <th>Connectivity</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="!connectivityNamcRows.length">
            <td colspan="11" class="muted">No connectivity data available.</td>
          </tr>
          <ng-container *ngFor="let namc of connectivityNamcRows; trackBy: trackByName">
            <tr class="namc-row">
              <td>
                <button type="button" class="conn-expand-button" [attr.aria-expanded]="isConnNamcExpanded(namc.name)"
                  (click)="toggleConnNamc(namc.name)">
                  <span class="expand-chevron" [class.expand-chevron--open]="isConnNamcExpanded(namc.name)" aria-hidden="true">&#9656;</span>
                  <strong>{{ namc.name }}</strong>
                </button>
              </td>
              <td class="numeric">{{ namc.shopCoverage }}</td>
              <td class="numeric">-</td>
              <ng-container *ngTemplateOutlet="metricCells; context: { $implicit: namc, connectivity: namc.percent_connected }"></ng-container>
            </tr>
            <ng-container *ngIf="isConnNamcExpanded(namc.name)">
              <tr class="shop-row" *ngFor="let shop of namc.children; trackBy: trackByName">
                <td>{{ shop.name }}</td>
                <td class="numeric">-</td>
                <td class="numeric">{{ shop.saykaStatus }}</td>
                <ng-container *ngTemplateOutlet="metricCells; context: { $implicit: shop, connectivity: shop.connectivityStatusBar }"></ng-container>
              </tr>
            </ng-container>
          </ng-container>
        </tbody>
      </table>
    </div>
  </article>
</div>

<!-- NAMC category totals and shop metrics share the same columns. -->
<ng-template #metricCells let-row let-connectivity="connectivity">
  <td class="numeric td-connected">{{ row.equipmentConnected === null ? '-' : (row.equipmentConnected | number) }}</td>
  <td class="numeric td-missing">{{ row.equipmentPlanned === null ? '-' : (row.equipmentPlanned | number) }}</td>
  <td class="numeric td-connected-pct">
    <ng-container *ngTemplateOutlet="percentageBar; context: { $implicit: row.equipmentConnectivityPct, status: percentageStatus(row.equipmentConnectivityPct) }"></ng-container>
  </td>
  <td class="numeric">{{ row.pdmSensorsConfigured === null ? '-' : (row.pdmSensorsConfigured | number) }}</td>
  <td class="numeric">{{ row.pdmSensorsPlanned === null ? '-' : (row.pdmSensorsPlanned | number) }}</td>
  <td class="numeric td-connected-pct">
    <ng-container *ngTemplateOutlet="percentageBar; context: { $implicit: row.pdmSensorsConnectivityPct, status: percentageStatus(row.pdmSensorsConnectivityPct) }"></ng-container>
  </td>
  <td class="numeric td-connected-pct">
    <ng-container *ngTemplateOutlet="percentageBar; context: { $implicit: connectivity, status: row.status }"></ng-container>
  </td>
  <td><span class="status-badge" [ngClass]="connStatusClass(row.status)">{{ row.status }}</span></td>
</ng-template>

<ng-template #percentageBar let-pct let-status="status">
  <div class="inline-bar-wrap">
    <div class="inline-bar-track">
      <div class="inline-bar-fill" [ngClass]="barClass(status)" [style.width.%]="pct ?? 0"></div>
    </div>
    <span>{{ pct === null ? '-' : (pct | number:'1.1-1') + '%' }}</span>
  </div>
</ng-template>